<template>
  <v-list-item
    class="ag-list-item"
    link
    :exact="exact"
    :disabled="disabled"
    :has-subtitle="!!subtitle"
    :active="active"
    :to="to"
    @click="$emit('click')"
  >
    <template v-if="showCheckbox || icon" #prepend>
      <v-checkbox v-if="showCheckbox" hide-details :model-value="active" @click="$emit('click')" />

      <AGIcon v-if="icon" class="icon-profile" :icon="icon" :size="iconSize" />
    </template>

    <v-list-item-title>
      <div class="d-flex justify-space-between align-center">
        {{ title }}
        <slot name="append" />
      </div>
    </v-list-item-title>
    <v-list-item-subtitle v-if="subtitle">{{ subtitle }}</v-list-item-subtitle>
  </v-list-item>
</template>

<script>
import AGIcon from '@/components/common/AGIcon.vue';
export default {
  components: {
    AGIcon,
  },

  emits: ['click'],

  props: {
    title: {
      type: String,
      default: '',
    },

    subtitle: {
      type: String,
      default: '',
    },

    active: {
      type: Boolean,
      default: undefined,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    showCheckbox: {
      type: Boolean,
      default: false,
    },

    icon: {
      type: String,
      default: null,
    },

    iconSize: {
      type: String,
      required: '',
    },

    to: {
      type: [String, Object],
      default: undefined,
    },

    exact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.icon-profile {
  color: rgb(var(--v-theme-primary));
  padding-right: 10px;
}

.ag-list-item {
  min-height: 56px !important;
  max-height: 56px;

  .v-list-item-title {
    font-size: $font-size-xs;
    font-weight: $font-weight-regular;
    line-height: 18.62px;
    letter-spacing: 0.01em;
    text-align: left;
    color: $neutral-color-high-dark;
  }

  .v-list-item-subtitle {
    font-size: $font-size-xxs;
    font-weight: $font-weight-regular;
    line-height: 18.62px;
    letter-spacing: 0.01em;
    opacity: 1;
    color: $neutral-color-high-medium !important;
  }

  ::v-deep(.v-list-item__content) {
    padding: 0;
  }

  ::v-deep(.v-list-item__action) {
    margin: 0 4px 0 0;
  }

  &[has-subtitle='true'] {
    min-height: 70px;
    max-height: 70px;

    .v-list-item-title {
      font-weight: $font-weight-bold;
    }
  }

  &:before {
    opacity: 0 !important;
  }

  &:hover {
    background-color: $brand-color-highlight-light !important;
  }

  &:active,
  &.v-list-item--active {
    background-color: $brand-color-primary-light !important;
  }

  &.v-list-item--disabled {
    opacity: 1;

    .v-list-item-title,
    .v-list-item-subtitle {
      color: $neutral-color-high-medium;
    }
  }

  ::v-deep(.v-list-item__overlay) {
    display: none;
  }
}
</style>
